export default __webpack_public_path__ + "static/media/numbered-list.789599f7.svg";